<template>
  <div class="template-auth">
    <main class="flex-fill">
      <div class="d-flex align-items-center">
        <slot />
      </div>
      <div class="side-img d-none d-md-block" />
    </main>

    <app-footer />
  </div>
</template>

<script>
import AppFooter from "@/components/template/AppFooter";

export default {
  components: { AppFooter }
};
</script>

<style lang="scss" scoped>
.template-auth {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  main {
    display: flex;

    > div {
      flex: 1 1 50%;
    }
  }

  .side-img {
    background-image: radial-gradient(#0000 30%, #131212f8 70%),
      url("../assets/images/bg-login.png");
    background-size: cover;
    background-position: center center;
  }
}
</style>
